import { useNavigate } from 'react-router';
import { FavoriteTeamGate } from '@/components/FavoriteTeamGate';

export function RerollPage() {
  const navigate = useNavigate();
  return <FavoriteTeamGate onSuccess={() => navigate('/profile')} />;
}
